import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule, Routes } from "@angular/router";
import { FuseConfirmDialogModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatCarouselModule } from "@ngmodule/material-carousel";
import { TranslateModule } from "@ngx-translate/core";
import {
  CalendarModule as AngularCalendarModule,
  DateAdapter,
} from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { SharedModule } from "app/helper-components/Shared.module";
import { ColorPickerModule } from "ngx-color-picker";
// import { S3Image } from "app/helper-components/S3Image";
import { AppointmentProgressModule } from "../appointment-progress/appointment-progress.module";
import { SingleventComponent } from "./singlevent.component";

const routes: Routes = [
  {
    path: "singleEvent",
    component: SingleventComponent,
  },
];

@NgModule({
  declarations: [SingleventComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTabsModule,
    TranslateModule,
    MatCardModule,
    AngularCalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ColorPickerModule,

    FuseSharedModule,
    FuseConfirmDialogModule,
    MatSelectModule,
    SharedModule,
    MatMenuModule,
    AppointmentProgressModule,
    MatCarouselModule,
    MatTableModule
  ],
})
export class SingleventModule {}
